import { SECURE_KEY }  from "../constants";

const initialState = {}

const getExperianReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case SECURE_KEY.GET_USER_SUCCESS:
            return {
                 ...state,
                 ...payload
             }
        case SECURE_KEY.GET_USER_FAIL:
            return {
                ...payload
            }
        default:
            return state;
    }
}

export default getExperianReducer;